import Snackbar from '@material-ui/core/Snackbar';
import EditIcon from '@material-ui/icons/Edit';
import MuiAlert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import Button from 'components/Button';
import { APP_MODULES } from 'constants/appModules';
import { OptionType } from 'helpers/WellHelper';
import React from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';
import { components, MenuProps } from 'react-select';
import { WellFullDetailsWithUniqueKeyDTO } from 'types/well';

import styles from './WellSelect.module.scss';
import FavouritePopin from './components/FavouritePopin';
import { useWellSelect } from './useWellSelect';

export interface Props {
  currentModule?: APP_MODULES | null;
  wellboresLoading: boolean;
  wellOptions: Array<{
    label: string;
    options: OptionType[];
  }>;
  wells: WellFullDetailsWithUniqueKeyDTO[];
  path: string;
  tightWellAccessible?: boolean;
  isFavouriteVisible?: boolean;
  propMenuStyle?: string;
  dropdownPropStyle?: string;
  closePopUp?: Function;
}

const WellSelect: React.FC<Props> = ({
  currentModule,
  wellboresLoading,
  wellOptions,
  wells,
  path,
  tightWellAccessible,
  isFavouriteVisible = true,
  propMenuStyle,
  dropdownPropStyle,
  closePopUp,
}) => {
  const intl = useIntl();
  const {
    snackbarOpen,
    setSnackbarOpen,
    selectedWell,
    onWellboreChange,
    favouritePopinIsOpen,
    handleFavouritePopinOnClose,
    filterOptions,
    handleManageYourFavouriteOnClick,
  } = useWellSelect({
    currentModule,
    wellboresLoading,
    wellOptions,
    wells,
    path,
    tightWellAccessible,
    isFavouriteVisible,
    propMenuStyle,
    dropdownPropStyle,
    closePopUp,
  });
  const Menu = (props: MenuProps<OptionType>) => (
    <>
      <components.Menu {...props}>
        <div className={clsx(styles.menuContainer, propMenuStyle)}>
          {props.children}
          <hr className={styles.line} />
          {isFavouriteVisible && (
            <Button
              className={styles.manageYourFavouriteButton}
              onClick={handleManageYourFavouriteOnClick}
            >
              {intl.formatMessage({ id: 'well-select.favouriteWellsManager' })}
              <EditIcon className={styles.editIcon} />
            </Button>
          )}
        </div>
      </components.Menu>
    </>
  );

  return (
    <div className={clsx(styles.sidebarReactSelectContainer, dropdownPropStyle)}>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => {
          setSnackbarOpen(false);
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => {
            setSnackbarOpen(false);
          }}
          severity="error"
        >
          {intl.formatMessage({ id: 'header.tuwiNotFoundError' })}
        </MuiAlert>
      </Snackbar>
      <Select
        placeholder={intl.formatMessage({ id: 'header.selectWellPlaceholder' })}
        classNamePrefix="common-react-select"
        value={selectedWell}
        options={wellOptions}
        onChange={(selectedOption: any) => onWellboreChange(selectedOption)}
        isLoading={wellboresLoading}
        components={{ Menu }}
        filterOption={filterOptions}
      />
      {isFavouriteVisible && (
        <FavouritePopin open={favouritePopinIsOpen} onClose={handleFavouritePopinOnClose} />
      )}
    </div>
  );
};

export default WellSelect;
